export enum Role {
  Admin = 'admin',
  Auditor = 'auditor',
}
